<template lang="pug">
#empresa-tabela-territorio-produtor
    el-table(
        ref='multipleTable',
        :data='territoriosVerificados',
        style='width: 100%; flex: 1',
        :row-class-name='rowClassName'
    )
        el-table-column(type='expand', width='40')
            template(#default='scope')
                .info-expand(
                    v-if='existeAlerta(scope.row.volumeAgrupado, scope.row.volumeContratado)'
                )
                    span {{ getMensagemAlerta(scope.row.volumeAgrupado, scope.row.volumeContratado, scope.row.revenda) }}

        el-table-column(
            property='numeroCtg',
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.uploadTerritoriosProdutores.numero")'
        )
        el-table-column(
            property='revenda',
            width='180',
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.uploadTerritoriosProdutores.corredor")',
            sortable
        )
        el-table-column(
            property='localDestino',
            width='180',
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.uploadTerritoriosProdutores.local")',
            sortable
        )
        el-table-column(
            property='ciudadDestino',
            width='180',
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.uploadTerritoriosProdutores.cidade")',
            sortable
        )
        el-table-column(
            property='descripcionMaterial',
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.uploadTerritoriosProdutores.descricao")'
        )
        el-table-column(
            property='localDestino',
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.uploadTerritoriosProdutores.localidade")'
        )
        el-table-column(
            property='cuit',
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.uploadTerritoriosProdutores.cuit")'
        )
        el-table-column(
            property='cantidadEjecutar',
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.uploadTerritoriosProdutores.volumeToneladas")'
        )
        el-table-column(
            prop='status',
            :label='$t("mensagens.relatorioRastreabilidade.listagem.status")'
        )
            template(slot='default', slot-scope='{ row }')
                | {{ row.status ? $t(`mensagens.subEmpresaGestao.status.${row.status}`) : $t('mensagens.sig.erro.naoinformado') }}
</template>

<script>
export default {
    name: 'TabelaVerificacaoTerritoriosProdutores',
    props: {
        territoriosVerificados: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            expandedRow: null
        };
    },
    methods: {
        existeAlerta(cantidadEjecutar, volumeContratado) {
            return volumeContratado !== null && cantidadEjecutar !== null;
        },

        getMensagemAlerta(cantidadEjecutar, volumeContratado, revenda) {
            const textoRevenda = this.$t(
                'mensagens.rastreabilidadeEmpresa.contratos.uploadTerritoriosProdutores.revenda'
            );
            const textoVolume = this.$t(
                'mensagens.rastreabilidadeEmpresa.contratos.uploadTerritoriosProdutores.entrega'
            );
            const textoErro = `${textoRevenda} ${revenda} ${textoVolume} ${cantidadEjecutar}/${volumeContratado}`;
            return textoErro;
        },

        rowClassName({ row }) {
            return this.existeAlerta(row.cantidadEjecutar, row.volumeContratado)
                ? 'row-has-alert'
                : 'row-no-alert';
        }
    }
};
</script>

<style lang="scss">
#empresa-tabela-territorio-produtor {
    .el-table th.el-table__cell > .cell {
        font-weight: 500;
        font-size: 14px;
        font-family: 'Roboto';
    }
    .el-table td.el-table__cell div {
        font-weight: normal;
        font-size: 14px;
        font-family: 'Roboto';
    }
    .el-checkbox__inner {
        border: 1.5px solid #3b3b3b;
    }
    .info-expand {
        padding: 0px 50px;
        font-size: 14px;
        p {
            margin: 0px;
        }
    }
    .expand-button {
        background: transparent;
        border: none;
        cursor: pointer;

        &:focus {
            outline: none;
        }
    }
    .row-no-alert .el-table__expand-icon {
        display: none;
    }

    button {
        width: 12px;
        background: transparent;
        border: 0;
        color: #3b3b3b;
        cursor: pointer;
        &:focus {
            outline: 0;
        }
    }
}
</style>
